import React from 'react';
import { Button, Checkbox } from 'antd';

interface MultiSelectCheckboxGroupProps {
  label: string;
  options: string[];
  selected: string[];
  setSelected: (selected: string[]) => void;
  otherInputValue?: string;
  checked: boolean;
  showCheckBox?: boolean;
  error?: string;
  setChecked: (checked: boolean) => void;
  setOtherInputValue?: (value: string) => void;
}

const MultiSelectCheckboxGroup: React.FC<MultiSelectCheckboxGroupProps> = ({
  label,
  options = [],
  selected = [],
  otherInputValue,
  setOtherInputValue,
  checked,setSelected,
  setChecked,  showCheckBox = true,error='',
}) => {


  return (
    <div className="col-span-1">
      {showCheckBox ? <Checkbox
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
        className="common-bold-label"
      >
        {label} {error!==''&&selected.length===0  && 
          <div className="text-red-500 text-sm !my-0">{error}</div>}
      </Checkbox> : <p className="common-bold-label">{label}
      {error!==''&&selected.length===0 && 
          <div className="text-red-500 text-sm !my-0">{error}</div>}
        </p>}

      {checked && (
        <div className="flex flex-wrap gap-x-2 gap-y-2 mt-[24px]">
          {options.map((option) => (
            <Button
            
              type='text'
              key={option}
              // onClick={() => (selected.includes(option)) && option === 'Other' ? '' : toggleSelection(option)}
              onClick={() => {
             if ( selected.includes(option) && option === 'Other') {} else
              {
                if (option === 'None') {
                  setSelected(['None']); // Clear all, only select 'None'
                } else {
                  const updatedSelection = selected.includes(option)
                    ? selected.filter((item) => item !== option)
                    : [...selected.filter((item) => item !== 'None'), option]; // Remove 'None' if present
                  setSelected(updatedSelection);
                }
              }}}
              
              
              className={`cursor-pointer rounded-[30px] px-[20px] py-[10px]  text-sm font-normal font-['Inter'] leading-tight  transition ${selected.includes(option)
                  ? 'text-[#1849a9] '
                  : 'text-[#1d2939]'
                }`}
              style={{
                border: `1px solid ${selected.includes(option) ? '#53b1fd' : '#e4e7ec'}`,
                backgroundColor: `${selected.includes(option) ? '#d1e9ff' : ''}`,
               

              }}

            >
              {(selected.includes(option)) && option === 'Other' ? (
                <div>  <input
                  type="text"
                  placeholder="Your Answer"

                  className="outline-none border-none bg-transparent text-[#1d2939] text-sm "
                  value={otherInputValue}
                  onChange={(e) => setOtherInputValue && setOtherInputValue(e.target.value)}
                /></div>
              ) : (
                option
              )}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectCheckboxGroup;
